import React, { FC, useRef } from 'react';
import styleModule from './RecruiterLandingFeaturesSection.module.less';
import Link from 'next/link';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'antd';
import Image from 'next/image';
import { RightOutlined } from '@ant-design/icons';
import { useUserInfo } from '../../../connection/Application';
import { Title } from '../../../components/Typogrphy/Title';
import { PlusOutlined } from '@ant-design/icons';
import ML from '../../../public/recruiter/recruiter-landing/ML.svg';
import BlockChain from '../../../public/recruiter/recruiter-landing/BlockChain.svg';
import AI from '../../../public/recruiter/recruiter-landing/AI.svg';
import { useRouter } from 'next/router';
import Externallink from '../../../public/recruiter/recruiter-landing/externallink.svg';
import background from '../../../public/recruiter/recruiter-landing/featuresimage.png';
import PlayBtn from '../../../public/recruiter/recruiter-landing/PlayBtn.svg';
import RequestDemoModal, { RequestDemoInstance } from './RequestDemoModal';
const styles: any = styleModule;

export const RecruiterLandingFeaturesSection: FC = () => {
  const user = useUserInfo();
  const history = useRouter();
  const demo = useRef<RequestDemoInstance>(null);
  return (
    <section className="relative w-screen self-center flex justify-center mt-[-20px] bg-[#f6fbfa] text-[#050931]">
      <div
        className={`${styles.maincont} w-full max-w-[1600px] px-[20px] md:px-[65px] py-[40px] flex items-center z-10 flex-col lg:flex-row gap-8 lg:gap-0 justify-between`}>
        <div>
          <span className={styles.Heading}>
            <span style={{ color: '#009E52' }}>Unique features </span> come to <br /> life with the
            latest in <br />
            technology
          </span>
          <div className={styles.stepsList}>
            <div className={styles.step}>
              <div className={styles.featureicon}>
                <Image width={30} height={30} src={AI} alt="Artificial Intelligence" />
              </div>
              <div className={styles.label}>Artificial Intelligence </div>
            </div>
            <div className={styles.step}>
              <div className={styles.featureicon}>
                <Image width={30} height={30} src={ML} alt="Machine Learning" />
              </div>
              <div className={styles.label}>Machine Learning</div>
            </div>
            <div className={styles.step}>
              <div className={styles.featureicon}>
                <Image width={30} height={30} src={BlockChain} alt="Analytics & Block Chain" />
              </div>
              <div className={styles.label}>Analytics & Block Chain</div>
            </div>
          </div>
          <div className={styles.deskbtn}>
            <Button
              size={'large'}
              type={'primary'}
              onClick={() => {
                demo.current?.show();
              }}
              className={styles.stepsDemobtn}>
              <b style={{ fontWeight: 'bolder' }}>
                Request a Demo
                <RightOutlined className={styles.arrow} />
              </b>
            </Button>
          </div>
          <div className={styles.mobilebtn}>
            <Button
              size={'middle'}
              type={'primary'}
              onClick={() => {
                demo.current?.show();
              }}
              className={styles.bannerButton}>
              <b style={{ fontWeight: 'bolder', paddingLeft: '15px' }}>
                {' '}
                Request a Demo
                <RightOutlined className={styles.arrow} />
              </b>
            </Button>
          </div>
        </div>

        <div className={styles.bannerImageFeatures}>
          <div
            style={{
              position: 'relative',
              width: 'fitContent',
              height: '100%',
              display: 'flex',
              // justifyContent: 'center',
            }}>
            <div
              style={{
                position: 'relative',
                width: 'fitContent',
                height: '100%',
                display: 'flex',
                // justifyContent: 'center',
              }}>
              <Image
                src={background}
                alt={'Banner Background'}
                className={styles.bannerImage}
                // style={{
                //   color: 'transparent',
                //   position: 'inherit',
                //   width: '600px',
                //   height: '500px',
                //   margin: 'auto',
                // }}
              />
              <Image src={PlayBtn} alt={'Banner Background'} className={styles.playBtn} />
            </div>
            <RequestDemoModal ref={demo} plan={'Demo'} />
          </div>

          {/* <div
    style={{
      position: 'relative',
      width: 'fitContent',
      height: '100%',
      display: 'flex',
      // justifyContent: 'center',
    }}>
    <Image src={background} alt={'Banner Background'} className={styles.playImg} />
    <Image src={PlayBtn} alt={'Banner Background'} className={styles.playBtn} />
  </div> */}
        </div>
      </div>
    </section>
  );
};

//button
{
  /* <div className={styles.deskbtn}>
              <Button
                size={'large'}
                type={'primary'}
                onClick={() => {
                  demo.current?.show();
                }}
                className={styles.stepsDemobtn}>
                <b style={{ fontWeight: 'bolder' }}>
                  Request a Demo
                  <RightOutlined className={styles.arrow} />
                </b>
              </Button>
            </div>
            <div className={styles.mobilebtn}>
              <Button
                size={'middle'}
                type={'primary'}
                onClick={() => {
                  demo.current?.show();
                }}
                className={styles.bannerButton}>
                <b style={{ fontWeight: 'bolder', paddingLeft: '15px' }}>
                  {' '}
                  Request a Demo
                  <RightOutlined className={styles.arrow} />
                </b>
              </Button>
            </div> */
}

//right div
{
  /* <span className={styles.Heading}>
<span style={{ color: '#009E52' }}>Unique features </span> come to <br /> life with
the latest in <br />
technology
</span>
<div className={styles.stepsList}>
<div className={styles.step}>
  <div className={styles.featureicon}>
    <Image width={30} height={30} src={AI} alt="Artificial Intelligence" />
  </div>
  <div className={styles.label}>Artificial Intelligence </div>
</div>
<div className={styles.step}>
  <div className={styles.featureicon}>
    <Image width={30} height={30} src={ML} alt="Machine Learning" />
  </div>
  <div className={styles.label}>Machine Learning</div>
</div>
<div className={styles.step}>
  <div className={styles.featureicon}>
    <Image width={30} height={30} src={BlockChain} alt="Analytics & Block Chain" />
  </div>
  <div className={styles.label}>Analytics & Block Chain</div>
</div>
</div>
<div className={styles.deskbtn}>
<Button
  size={'large'}
  type={'primary'}
  onClick={() => {
    demo.current?.show();
  }}
  className={styles.stepsDemobtn}>
  <b style={{ fontWeight: 'bolder' }}>
    Request a Demo
    <RightOutlined className={styles.arrow} />
  </b>
</Button>
</div>
<div className={styles.mobilebtn}>
<Button
  size={'middle'}
  type={'primary'}
  onClick={() => {
    demo.current?.show();
  }}
  className={styles.bannerButton}>
  <b style={{ fontWeight: 'bolder', paddingLeft: '15px' }}>
    {' '}
    Request a Demo
    <RightOutlined className={styles.arrow} />
  </b>
</Button>
</div> */
}

// image div
